interface Config {
  SURVEY_SERVER_URL: any;
  mode: string;
  REST_API_URLS: string;
  FORM_SERVER_URL: string;
  LOCATION_SERVER_URL: string;
  FUNNEL_SERVER_URL: string;
  EMAIL_SERVER_URL: string;
  FORM_EMBED_URL: string;
  PAYMENT_SERVER_URL: string;
  PAYMENT_BACKEND_URL: string;
  PRODUCT_SERVER_URL: string;
  OPPORTUNITY_SERVER_URL: string;
  ASSOCIATIONS_SERVER_URL: string;
  GHL_DOMAIN: string;
  GHL_DOMAIN_UI: string;
  WORKFLOW_SEARCH_URL: string;
  WORKFLOW_SERVER_URL: string;
}

const config: { [key: string]: Config } = {
  development: {
    mode: "dev",
    WORKFLOW_SEARCH_URL: "https://staging.backend.leadconnectorhq.com",
    WORKFLOW_SERVER_URL: "https://staging.backend.leadconnectorhq.com/workflow",
    REST_API_URLS: "https://staging.services.leadconnectorhq.com",
    FORM_SERVER_URL: "https://staging.services.leadconnectorhq.com",
    SURVEY_SERVER_URL: "https://staging.services.leadconnectorhq.com",
    LOCATION_SERVER_URL: "https://staging.services.leadconnectorhq.com",
    FUNNEL_SERVER_URL: "https://staging.services.leadconnectorhq.com",
    EMAIL_SERVER_URL: "https://staging.services.leadconnectorhq.com",
    FORM_EMBED_URL: "https://staging.link.gohighlevel.com/js",
    PAYMENT_SERVER_URL: "https://staging.services.leadconnectorhq.com",
    PAYMENT_BACKEND_URL: "https://staging.backend.leadconnectorhq.com",
    PRODUCT_SERVER_URL: "https://staging.services.leadconnectorhq.com",
    OPPORTUNITY_SERVER_URL: "https://staging.services.leadconnectorhq.com",
    ASSOCIATIONS_SERVER_URL: "https://staging.services.leadconnectorhq.com",
    GHL_DOMAIN: "localhost:8080",
    GHL_DOMAIN_UI: "http://localhost:3344",
  },
  staging: {
    mode: "staging",
    WORKFLOW_SEARCH_URL: "https://staging.backend.leadconnectorhq.com",
    WORKFLOW_SERVER_URL: "https://staging.backend.leadconnectorhq.com/workflow",
    REST_API_URLS: "https://staging.services.leadconnectorhq.com",
    FORM_SERVER_URL: "https://staging.services.leadconnectorhq.com",
    SURVEY_SERVER_URL: "https://staging.services.leadconnectorhq.com",
    LOCATION_SERVER_URL: "https://staging.services.leadconnectorhq.com",
    FUNNEL_SERVER_URL: "https://staging.services.leadconnectorhq.com",
    EMAIL_SERVER_URL: "https://staging.services.leadconnectorhq.com",
    FORM_EMBED_URL: "https://staging.link.gohighlevel.com/js",
    PAYMENT_SERVER_URL: "https://staging.services.leadconnectorhq.com",
    PAYMENT_BACKEND_URL: "https://staging.backend.leadconnectorhq.com",
    PRODUCT_SERVER_URL: "https://staging.services.leadconnectorhq.com",
    OPPORTUNITY_SERVER_URL: "https://staging.services.leadconnectorhq.com",
    ASSOCIATIONS_SERVER_URL: "https://staging.services.leadconnectorhq.com",
    GHL_DOMAIN: "staging.gohighlevel.com",
    GHL_DOMAIN_UI: "https://quizzes-dot-funnel-preview-dot-highlevel-staging.uc.r.appspot.com", // "https://staging.gohighlevel.com",
  },
  interop: {
    mode: "interop",
    WORKFLOW_SEARCH_URL: "https://interop.backend.leadconnectorhq.com",
    WORKFLOW_SERVER_URL: "https://interop.backend.leadconnectorhq.com/workflow",
    REST_API_URLS: "https://interop.services.leadconnectorhq.com",
    FORM_SERVER_URL: "https://interop.services.leadconnectorhq.com",
    SURVEY_SERVER_URL: "https://interop.services.leadconnectorhq.com",
    LOCATION_SERVER_URL: "https://interop.services.leadconnectorhq.com",
    FUNNEL_SERVER_URL: "https://interop.services.leadconnectorhq.com",
    EMAIL_SERVER_URL: "https://interop.services.leadconnectorhq.com",
    FORM_EMBED_URL: "https://link.msgsndr.com/js",
    PAYMENT_SERVER_URL: "https://interop.services.leadconnectorhq.com",
    PAYMENT_BACKEND_URL: "https://interop.backend.leadconnectorhq.com",
    PRODUCT_SERVER_URL: "https://interop.services.leadconnectorhq.com",
    OPPORTUNITY_SERVER_URL: "https://interop.services.leadconnectorhq.com",
    ASSOCIATIONS_SERVER_URL: "https://interop.services.leadconnectorhq.com",
    GHL_DOMAIN: "app.gohighlevel.com",
    GHL_DOMAIN_UI: "https://link.apisystem.tech",
  },
  beta: {
    mode: "beta",
    WORKFLOW_SEARCH_URL: "https://beta.backend.leadconnectorhq.com",
    // Mirrors spm-ts constants.ts, which points beta workflow calls at the production backend (Q-W5)
    WORKFLOW_SERVER_URL: "https://backend.leadconnectorhq.com/workflow",
    REST_API_URLS: "https://services.leadconnectorhq.com",
    FORM_SERVER_URL: "https://services.leadconnectorhq.com",
    SURVEY_SERVER_URL: "https://services.leadconnectorhq.com",
    LOCATION_SERVER_URL: "https://services.leadconnectorhq.com",
    FUNNEL_SERVER_URL: "https://services.leadconnectorhq.com",
    EMAIL_SERVER_URL: "https://services.leadconnectorhq.com",
    FORM_EMBED_URL: "https://link.msgsndr.com/js",
    PAYMENT_SERVER_URL: "https://services.leadconnectorhq.com",
    PAYMENT_BACKEND_URL: "https://backend.leadconnectorhq.com",
    PRODUCT_SERVER_URL: "https://services.leadconnectorhq.com",
    OPPORTUNITY_SERVER_URL: "https://services.leadconnectorhq.com",
    ASSOCIATIONS_SERVER_URL: "https://services.leadconnectorhq.com",
    GHL_DOMAIN: "app.gohighlevel.com",
    GHL_DOMAIN_UI: "https://link.apisystem.tech",
  },
  production: {
    mode: "production",
    WORKFLOW_SEARCH_URL: "https://backend.leadconnectorhq.com",
    WORKFLOW_SERVER_URL: "https://backend.leadconnectorhq.com/workflow",
    REST_API_URLS: "https://services.leadconnectorhq.com",
    FORM_SERVER_URL: "https://services.leadconnectorhq.com",
    SURVEY_SERVER_URL: "https://services.leadconnectorhq.com",
    LOCATION_SERVER_URL: "https://services.leadconnectorhq.com",
    FUNNEL_SERVER_URL: "https://services.leadconnectorhq.com",
    EMAIL_SERVER_URL: "https://services.leadconnectorhq.com",
    FORM_EMBED_URL: "https://link.msgsndr.com/js",
    PAYMENT_SERVER_URL: "https://services.leadconnectorhq.com",
    PAYMENT_BACKEND_URL: "https://backend.leadconnectorhq.com",
    PRODUCT_SERVER_URL: "https://services.leadconnectorhq.com",
    OPPORTUNITY_SERVER_URL: "https://services.leadconnectorhq.com",
    ASSOCIATIONS_SERVER_URL: "https://services.leadconnectorhq.com",
    GHL_DOMAIN: "app.gohighlevel.com",
    GHL_DOMAIN_UI: "https://link.apisystem.tech",
  },
};

const override = false;

const overrideConfig = {
  override: true,
};
//@ts-ignore
const envConfig = config[process.env.NODE_ENV];

export default override ? { ...envConfig, ...overrideConfig } : envConfig;
